import { createSelector } from '@reduxjs/toolkit';
import { t } from 'src/i18n';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import { weekStart } from './week-start';
import { LocalDate } from '../../../utilities/local-date';
import type { LeavePeriodSummary } from './leave-period-summary';
import { leavePeriodPhrases } from './leave-period-phrases';
import { sortBy } from 'lodash';
import { periodTimeDisplayText } from '../staffing/period-time-display-text';
import { employeesForStaffingCalendar } from '../staffing/employees-for-staffing-calendar';

export const leavePeriods = createSelector(
  employeesForStaffingCalendar,
  currentEmployeeUuid,
  weekStart,
  (employees, currentEmployeeUuid, weekStart) => {
    const calStart = LocalDate.fromString(weekStart);
    const calEnd = calStart.plusDays(6);

    const result: LeavePeriodSummary[] = [];
    for (const item1 of employees) {
      const periods: {
        confirmed: boolean;
        type: string;
        start: string;
        end: string;
        startTime?: string;
        endTime?: string;
      }[] = item1.leavePeriods;

      for (const item of periods) {
        if (
          LocalDate.fromString(item.start).isSameOrBefore(calEnd) &&
          LocalDate.fromString(item.end).isSameOrAfter(calStart)
        ) {
          let employee = item1.displayName;
          if (item1.uuid === currentEmployeeUuid) {
            employee = t('staffing.leavePeriodCurrentEmployee');
          }
          let startTime = item.startTime;
          if (startTime === undefined) {
            startTime = '00:00';
          }
          let endTime = item.endTime;
          if (endTime === undefined) {
            endTime = '00:00';
          }
          const startDate = LocalDate.fromString(item.start);
          const endDate = LocalDate.fromString(item.end);
          const durationText = periodTimeDisplayText(startDate, startTime, endDate, endTime, false);
          const text = employee + ' ' + leavePeriodPhrases(item.type) + ' ' + durationText;

          const myPeriod = item1.uuid === currentEmployeeUuid;
          result.push({
            start: item.start,
            type: item.type,
            text: text,
            confirmed: item.confirmed,
            myPeriod: myPeriod,
          });
        }
      }
    }
    return sortBy(result, (e) => e.start);
  },
);
